import { z } from 'zod';
import { uuidSchema } from './common.schema.js';

// ── Entitlement keys ─────────────────────────────────────────────────────────
// Top-level module entitlements (gates) and fine-grained feature entitlements.
// Keys match the backend plan-role entitlements response exactly.

export const EntitlementKeySchema = z.enum([
  // Module-level gates
  'PATIENT_MANAGEMENT',
  'DONOR_MANAGEMENT',
  'MOTHER_MANAGEMENT',
  'INVENTORY',
  'RECALL',
  'MILK_MANAGEMENT',
  'FEED_MANAGEMENT',
  'PRINT_SCANNING',
  'ONBOARDING',
  'HELPDESK',
  'SETTINGS',
  'ROLE_DASHBOARD',
  'REPORTS',
  'DONOR_PORTAL',
  'USER_MANAGEMENT',
  'AUDIT_LOG',

  // Patient sub-features
  'patient.profile_communication',
  'patient.mother',

  // Inventory sub-features
  'inv.donor_milk_receive',
  'inv.mother_milk_receive',
  'inv.formulary',

  // Feed sub-features
  'feed.order_donor_only',
  'feed.order_donor_mother',
  'feed.order_full',
  'feed.order_product',
  'feed.feed_prep_donor_only',
  'feed.feed_prep_donor_mother',
  'feed.feed_prep_full',
  'feed.feed_prep_product',
  'feed.feed_administer',
  'feed.redosing',
  'feed.quick_feed',
]);
export type EntitlementKey = z.infer<typeof EntitlementKeySchema>;

// ── Entitlements map: { key → boolean } ──────────────────────────────────────

export const EntitlementsMapSchema = z.record(z.string(), z.boolean());
export type EntitlementsMap = z.infer<typeof EntitlementsMapSchema>;

// ── Plan flag ────────────────────────────────────────────────────────────────
export const PlanFlagSchema = z.enum(['P1', 'P2', 'P3']);
export type PlanFlag = z.infer<typeof PlanFlagSchema>;

// ── API response payload ─────────────────────────────────────────────────────

export const EntitlementsResponseSchema = z.object({
  tenant_id: uuidSchema,
  plan_code: z.string(),
  plan_flag: PlanFlagSchema,
  role_code: z.array(z.string()),
  entitlements: EntitlementsMapSchema,
});
export type EntitlementsResponse = z.infer<typeof EntitlementsResponseSchema>;
